import Vue from 'vue'
import Router from 'vue-router'
const homeindex = resolve => require(["../components/home"], resolve)
const course = resolve => require(["../components/curriculum/course"], resolve)
const payment = resolve => require(["../components/pay/payment"], resolve)
const complete = resolve => require(["../components/pay/complete"], resolve)
const coursepage = resolve => require(["../components/curriculum/coursepage"], resolve)

const plug = resolve => require(["../components/plug/plug"], resolve)
const plugcate = resolve => require(["../components/plug/plugcate"], resolve)

const news = resolve => require(["../components/news/news"], resolve)
const newsdetail = resolve => require(["../components/news/newsdetail"], resolve)

const about = resolve => require(["../components/about"], resolve)
const company = resolve => require(["../components/company"], resolve)

const login = resolve => require(["../components/auth/login"], resolve)
const register = resolve => require(["../components/auth/register"], resolve)
const verification = resolve => require(["../components/auth/verification"], resolve)
const forget = resolve => require(["../components/auth/forget"], resolve)
const reset = resolve => require(["../components/auth/reset"], resolve)

const periphery = resolve => require(["../components/periphery"], resolve)
const peripheryDetails = resolve => require(["../components/periphery/details"], resolve)
const search = resolve => require(["../components/search"], resolve)

const userIndex = resolve => require(["../components/user/index"], resolve)
const userCourse = resolve => require(["../components/user/course"], resolve)
const userInfo = resolve => require(["../components/user/info"], resolve)
const userCertification = resolve => require(["../components/user/certification"], resolve)
const userSecurity = resolve => require(["../components/user/security"], resolve)
const userSocialite = resolve => require(["../components/user/socialite"], resolve)
const userOrder = resolve => require(["../components/user/order"], resolve)
const userOrderDetail = resolve => require(["../components/user/orderDetail"], resolve)
const verifyResult = resolve => require(["../components/user/emailverify"], resolve)
const userIntegral = resolve => require(["../components/user/integral"], resolve)
const userRecharge = resolve => require(["../components/user/recharge"], resolve)
const message = resolve => require(["../components/user/message"], resolve)
const address = resolve => require(["../components/user/address"], resolve)
const contribute = resolve => require(["../components/user/contribute"], resolve)

const userfans = resolve => require(["../components/fans/userfans"], resolve)
const fansIndex = resolve => require(["../components/fans/index"], resolve)
const userfanslist = resolve => require(["../components/fans/userfanslist"], resolve)
const attentionlist = resolve => require(["../components/fans/attentionlist"], resolve)






Vue.use(Router)

const router = new Router({
  // mode: 'history',
  // base: '/',
  routes: [
    {
      path: '/',
      name: 'homeindex',
      meta: {
        requireAuth: false,
      },
      component: homeindex,
    },
    {
      path: '/index',
      name: 'index',
      meta: {
        requireAuth: false,
      },
      component: homeindex,
    },



    // login
    {
      path: '/login',
      name: 'login',
      meta: {
        requireAuth: false,
        isAuthRoute: true
      },
      component: login,
    }, {
      path: '/register',
      name: 'register',
      meta: {
        requireAuth: false,
        isAuthRoute: true
      },
      component: register
    }, {
      path: '/verification',
      name: 'verification',
      meta: {
        requireAuth: false,
        isAuthRoute: true
      },
      component: verification
    }, {
      path: '/forget',
      name: 'forget',
      meta: { requireAuth: false },
      component: forget
    }, {
      path: '/reset-password',
      name: 'reset-password',
      meta: { requireAuth: false },
      component: reset
    },
    {
      path: '/plug/:id',
      name: 'plug',
      component: plug,
      meta: { requireAuth: false },
      childern: []
    },
    {
      path: '/plug',
      name: 'plugcate',
      component: plugcate,
    },
    // knowledge
    {
      path: '/knowledge',
      name: 'knowledge',
      meta: { requireAuth: false },
      component: news,
      children: []
    }, {
      path: '/knowledge/:id',
      name: 'knowledgedetail',
      meta: { requireAuth: false },
      component: newsdetail
    },
    // email-verify
    {
      path: '/email-verify',
      name: 'email-verify',
      meta: { requireAuth: false },
      component: verifyResult
    },
    //aboutus
    {
      path: '/help',
      name: 'help',
      component: about
    },
    {
      path: '/company',
      name: 'company',
      meta: { requireAuth: false },
      component: company
    },
    // ai路由已隐藏
    // user
    {
      path: '/user',
      name: 'user',
      meta: { requireAuth: true },
      component: userIndex,
      redirect: '/user/info',
      children: [
        {
          path: '/user/info',
          name: 'userInfo',
          meta: { requireAuth: true },
          component: userInfo
        },
        //投稿管理
        {
          path: '/user/contribute',
          name: 'contribute',
          meta: { requireAuth: true },
          component: contribute
        },
        {
          path: '/user/order',
          name: 'userOrder',
          meta: { requireAuth: true },
          component: userOrder
        }, {
          path: '/user/order/:id',
          name: 'userOrderDetail',
          meta: { requireAuth: true },
          component: userOrderDetail
        }, {
          path: '/user/course',
          name: 'userCourse',
          meta: { requireAuth: true },
          component: userCourse
        }, {
          path: '/user/certification',
          name: 'userCertification',
          meta: { requireAuth: true },
          component: userCertification
        }, {
          path: '/user/security',
          name: 'userSecurity',
          meta: { requireAuth: true },
          component: userSecurity
        }, {
          path: '/user/socialite',
          name: 'userSocialite',
          meta: { requireAuth: true },
          component: userSocialite
        }, {
          path: '/user/integral',
          name: 'userIntegral',
          meta: { requireAuth: true },
          component: userIntegral
        }, {
          path: '/user/recharge',
          name: 'userRecharge',
          meta: { requireAuth: true },
          component: userRecharge
        }, {
          path: '/user/message',
          name: 'message',
          meta: { requireAuth: true },
          component: message
        }, {
          path: '/user/address',
          name: 'address',
          meta: { requireAuth: true },
          component: address
        }
      ],
    }, {
      path: '/course',
      name: 'course',
      meta: { requireAuth: false },
      component: course
    }, {
      path: '/coursepage/:id',
      name: 'coursepage',
      meta: { requireAuth: false },
      component: coursepage
    }, {
      path: '/payment',
      name: 'payment',
      meta: { requireAuth: true },
      component: payment
    }, {
      path: '/payment-result',
      name: 'payment-result',
      component: complete
    },
    // 周边
    {
      path: '/periphery',
      name: 'periphery',
      meta: { requireAuth: false },
      component: periphery
    },
    {
      path: '/periphery/:id',
      name: 'peripheryDetails',
      meta: { requireAuth: false },
      component: peripheryDetails
    },
    // 搜索结果
    {
      path: '/search',
      name: 'search',
      meta: { requireAuth: false },
      component: search
    },
    // 

    {
      path: '/userfans',
      name: 'userfans',
      meta: { requireAuth: true },
      component: fansIndex,
      children: [
        {
          path: '/userfans/:id',
          name: 'userfans',
          meta: { requireAuth: false },
          component: userfans
        },

        {
          path: '/userfanslist/:id',
          name: 'userfanslist',
          meta: {
            requireAuth: false,
          },
          component: userfanslist,
        },

        {
          path: '/attentionlist/:id',
          name: 'attentionlist',
          meta: {
            requireAuth: false,
          },
          component: attentionlist,
        }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireAuth)) {
    let token = localStorage.getItem('Authorization');
    if (token === null || token === '') {
      next('/login');
    } else {
      next();
    }
  } else {
    if (to.matched.some(record => record.meta.isAuthRoute)) {
      let token = localStorage.getItem('Authorization');
      if (token === null || token === '') {
        next();
      } else {
        next('/user/info');
      }
    } else {
      next();
    }
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js